// react
import { useCallback, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES, buildUrl } from 'router';

// components
import { OnboardingDirectory } from '@karehero/llama/components/organisms/OnboardingDirectory/OnboardingDirectory';

import OnboardingFlow, {
  OnboardingActionType,
} from '@karehero/llama/components/pages/OnboardingFlow/OnboardingFlow';

/**
 * OnboardingDirectoryAtHome takes the user through the onboarding flow for a care concierge.
 */
export const OnboardingDirectoryAtHome = () => {
  // state
  const [location, setLocation] = useState('');

  // hooks
  const navigate = useNavigate();

  // methods
  const handleComplete = useCallback(() => {
    navigate(buildUrl(ROUTES.DIRECTORY, { search: location }));
  }, [navigate, location]);

  // memos
  const onboardingDirectoryConfig = useMemo(
    () => [
      {
        id: 'directory',
        Component: OnboardingDirectory,
        config: [
          {
            id: '1',
            title: 'Where are you looking for care?',
            text: 'This will help us recommomend care services closest to the area you need',
            type: 'input',
            value: location,
            onChange: setLocation,
            actions: [
              {
                label: 'Next',
                onClick: OnboardingActionType.Next,
              },
            ],
          },
        ],
      },
    ],
    [location],
  );

  return (
    <OnboardingFlow
      config={onboardingDirectoryConfig}
      onComplete={handleComplete}
    />
  );
};

OnboardingDirectoryAtHome.displayName = 'OnboardingDirectoryAtHome';
export default OnboardingDirectoryAtHome;
